import styled from "styled-components";

export const ModalWrapper = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(18, 18, 20, 0.5);
  display: flex;
  justify-content: center;
  z-index: 1;

  & > div {
    align-self: center;
    position: absolute;
    width: 100%;
    max-width: 50rem;
    min-height: 35.7rem;
    border-radius: 0.6rem;
    background-color: var(--background);
    display: flex;
    flex-direction: column;
    gap: 2rem;

    & > :nth-child(1) {
      background-color: var(--color-primary);
      height: 6.5rem;
      display: flex;
      justify-content: space-between;
      padding: 0 2.2rem;
      align-items: center;
      border-radius: 0.5rem 0.5rem 0 0;

      & > h3 {
        height: initial;
      }

      & > button {
        background-color: transparent;
        outline: none;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
          opacity: 0.5;
        }
      }
    }
    & > ul {
      padding: 0rem 2.2rem;
      max-height: 20rem;
      display: flex;
      flex-direction: column;
      gap: 1.8rem;
      overflow-y: scroll;

      & > h3 {
        margin-top: 6rem;
        align-self: center;
      }

      & > span {
        align-self: center;
      }

      &::-webkit-scrollbar {
        appearance: none;
      }
    }
    & > span {
      width: 100%;
      max-width: 40.8rem;
      padding: 0 2.2rem;
      height: 0.2rem;
      background-color: var(--color-grey-20);
      align-self: center;
    }
  }
`;
